import React from 'react';
import { Pagination as MuiPagination } from '@mui/material';
import './Pagination.css';

/**
 * Generic Pagination Component
 * @param {Object} props
 * @param {number} props.page - Current page number (1-indexed)
 * @param {number} props.totalPages - Total number of pages
 * @param {number} props.totalItems - Total number of items
 * @param {number} props.itemsPerPage - Number of items per page
 * @param {Function} props.onPageChange - Callback function when page changes (receives new page number)
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showInfo - Whether to show pagination info text
 */
const Pagination = ({
  page = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  className = '',
  showInfo = true
}) => {
  const safeTotalPages = Math.max(1, totalPages || 1);
  const safePage = Math.min(Math.max(page, 1), safeTotalPages);

  const handleChange = (event, value) => {
    if (onPageChange) {
      onPageChange(value);
    }
  };

  const startItem = totalItems === 0 ? 0 : (safePage - 1) * itemsPerPage + 1;
  const endItem = Math.min(safePage * itemsPerPage, totalItems);

  return (
    <div className={`pagination-container ${className}`}>
      {showInfo && totalItems > 0 && (
        <div className="pagination-info-text">
          Showing {startItem} - {endItem} of {totalItems}
        </div>
      )}
      <MuiPagination
        count={safeTotalPages}
        page={safePage}
        onChange={handleChange}
        color="primary"
        shape="rounded"
        showFirstButton
        showLastButton
        className="mui-pagination"
      />
    </div>
  );
};

export default Pagination;

